import { AlpineComponent } from 'alpinejs';
import Chart from 'chart.js/auto';

const SectionComponent = (): AlpineComponent => ({
  init() {
    const data = [
      { year: 2010, count: 10 },
      { year: 2011, count: 20 },
      { year: 2012, count: 15 },
    ];

    const dataLineChart = {
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
      datasets: [
        {
          label: 'Dataset 1',
          data: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
          borderColor: '#009FE3',
          //backgroundColor: Utils.transparentize(Utils.CHART_COLORS.red, 0.5),
        },
        {
          label: 'Dataset 2',
          data: [0, 5, 57, 45, 58, 55, 40, 70, 42, 75, 100],
          borderColor: '#E6007E',
          //backgroundColor: Utils.transparentize(Utils.CHART_COLORS.blue, 0.5),
        }
      ]
    };

    let chartType = null;
    let config = null;

    if (document.getElementById('chart-pie')) {
      chartType = 'pie';
      config = {
        type: chartType,
        options: {
          animation: false,
          responsive: true,
          plugins: {
            tooltip: {
              enabled: true
            },
            legend: {
              position: 'top',
            }
          },
        },
        data: {
          labels: ['Red', 'Blue', 'Blue'],
          datasets: [
            {
              label: 'Acquisitions by year',
              data: data.map(row => row.count),
              backgroundColor: ["#009FE3", "#E6007E", "#5BC5F2"]
            }
          ]
        }
      }
    }
    
    if (document.getElementById('chart-line')) {
      chartType = 'line';
      config = {
        type: 'line',
        data: dataLineChart,
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'top',
            },
            title: {
              display: true,
              text: 'Chart.js Line Chart'
            }
          },
          scales: {
            y: {
              type: 'linear',
              display: true,
              position: 'right',
            }
          }
        },
      };
    }

    if (document.getElementById('chart-bar')) {
      chartType = 'bar';
            config = {
        type: chartType,
        options: {
          animation: false,
          responsive: true,
          plugins: {
            tooltip: {
              enabled: true
            },
            legend: {
              position: 'top',
            }
          },
        },
        data: {
          labels: ['Red', 'Blue', 'Blue'],
          datasets: [
            {
              label: 'Acquisitions by year',
              data: data.map(row => row.count),
              backgroundColor: ["#009FE3", "#E6007E", "#5BC5F2"]
            }
          ]
        }
      }
    }

    new Chart(
      document.getElementById(`chart-${chartType}`),
      config
    );
  }
});

export default SectionComponent;
